import './App.css';
import { Hero, Plans, Programs, Reasons, Testimonials } from './components';
import Footer from './components/Footer/Footer';
import Join from './components/Join/Join';
function App() {
  return (
    <div className="App">
      <Hero />
      <Programs />
      <Reasons />
      <Plans />
      <Testimonials />
      <Join />
      <Footer />
    </div>
  );
}

export default App;
